import {
	HostBinding,
	EventEmitter,
	Output,
	Injector,
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
} from '@angular/core';
import { EventsComponent } from '../events/events.component';
import { isEmpty, orderBy } from 'lodash';

@Component({
	selector: 'styled-button',
	encapsulation: ViewEncapsulation.None,
	template: `
		<label>
			<input
				type="radio"
				gtm-handler
				[attr.gtm]="gaLabel"
				events="click"
				handlerType="radio"
				[label]="gaLabel"
				action="RadioButton"
				[attr.aria-label]="parentName"
				[attr.aria-describedby]="name + '_error'"
				[name]="name"
				[(ngModel)]="selectedValue"
				[value]="value"
				(ngModelChange)="setStyledButtonAnswer()"
				[disabled]="disabled"
				[attr.name]="name"
				[title]="title"
			/>
			<span [attr.aria-label]="parentName" class="styled-button-title">{{ title }}</span>
		</label>
	`,
	styleUrls: ['./styled-button.component.scss'],
})
export class StyledButtonComponent extends EventsComponent implements OnInit {
	@Input() control: any;
	@Input() context: any;
	@Input() selectedValue: any;
	@Input() value: any;
	@Input() disabled: any;
	@Input() title: any;
	@Input() Name: any;
	@Input() attributes: attributes;
	@Input() parentName: any;
	@HostBinding('attr.name')
	name = this.setName();
	number: any;
	@Output() setAnswer: EventEmitter<any> = new EventEmitter();
	constructor(injector: Injector) {
		super(injector);
	}

	setStyledButtonAnswer() {
		this.setAnswer.emit(this.selectedValue);
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		this.number = this.observablesService.StyledButtonNumber++;
	}

	setName() {
		setTimeout(() => {
			this.name = this.Name;
		}, 300);
		return this.getName();
	}

	getName() {
		return !isEmpty(this.control) ? this.control.name : this.value;
	}
}
